import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Api from "../../utils/api";
export function getCards(_x) {
  return _getCards.apply(this, arguments);
}
function _getCards() {
  _getCards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state,
      commit,
      fresh,
      _yield$Api$get,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          state = _ref.state, commit = _ref.commit;
          fresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          if (!(state.cards && !fresh)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.cards);
        case 1:
          _context.next = 2;
          return Api().get('api/cards');
        case 2:
          _yield$Api$get = _context.sent;
          data = _yield$Api$get.data;
          commit('cards/setCards', data, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCards.apply(this, arguments);
}
export function addCard(_x2, _x3) {
  return _addCard.apply(this, arguments);
}
function _addCard() {
  _addCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, params) {
    var state, commit, p;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          state = _ref2.state, commit = _ref2.commit;
          p = JSON.parse(JSON.stringify(params));
          p.card_type_id = params.card_type_id.value;
          p.expiry = params.expiry.format('YYYY-MM-DD');
          _context2.next = 1;
          return Api().post('api/add-card', p);
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _addCard.apply(this, arguments);
}
export function setDefault(_x4, _x5) {
  return _setDefault.apply(this, arguments);
}
function _setDefault() {
  _setDefault = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, cardId) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          state = _ref3.state, commit = _ref3.commit;
          commit('cards/setDefault', cardId, {
            root: true
          });
          _context3.next = 1;
          return Api().post("api/default-card/".concat(cardId));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _setDefault.apply(this, arguments);
}
export function fixCard(_x6, _x7) {
  return _fixCard.apply(this, arguments);
}
function _fixCard() {
  _fixCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, params) {
    var state, commit, _yield$Api$post, data;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          state = _ref4.state, commit = _ref4.commit;
          _context4.next = 1;
          return Api().post('api/fix-card', params);
        case 1:
          _yield$Api$post = _context4.sent;
          data = _yield$Api$post.data;
          commit('cards/fixCard', data);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fixCard.apply(this, arguments);
}
export function deleteCard(_x8, _x9) {
  return _deleteCard.apply(this, arguments);
}
function _deleteCard() {
  _deleteCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, cardId) {
    var state, commit;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          state = _ref5.state, commit = _ref5.commit;
          _context5.next = 1;
          return Api().post("api/delete-card/".concat(cardId));
        case 1:
          commit('cards/deleteCard', cardId, {
            root: true
          });
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _deleteCard.apply(this, arguments);
}